import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import UserProfileService, { UserProfile } from '../../../services/UserProfileService';

const QUERY_KEY = 'userProfile';

// Get user profile
export function useUserProfile() {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => UserProfileService.getUserProfile(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

// Update user preferences
export function useUpdateUserPreferences() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (preferences: Partial<UserProfile['preferences']>) => {
      return UserProfileService.updatePreferences(preferences);
    },
    onSuccess: (updatedProfile) => {
      queryClient.setQueryData([QUERY_KEY], updatedProfile);
    },
    onError: (error) => {
      console.error('Failed to update user preferences:', error);
    },
  });
}

// Update user stats
export function useUpdateUserStats() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (stats: Partial<UserProfile['stats']>) => {
      return UserProfileService.updateStats(stats);
    },
    onSuccess: (updatedProfile) => {
      queryClient.setQueryData([QUERY_KEY], updatedProfile);
    },
    onError: (error) => {
      console.error('Failed to update user stats:', error);
    },
  });
}

// Get user display info
export function useUserDisplayInfo() {
  return useQuery({
    queryKey: [QUERY_KEY, 'display'],
    queryFn: () => UserProfileService.getUserDisplayInfo(),
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
} 